import {takeEvery, put} from 'redux-saga/effects';
/* Actions */
import {ActionTypes} from './user-actions';
import {steveDataStorage} from '../../helpers/sdk-helpers';
import UserService from '../../services/user-service';

function* changeDashboardLibraryLayout({layout}) {
  steveDataStorage('dashboards', 'view', false).set(layout, 'layout');
  yield put({
    type: ActionTypes.SET_DASHBOARD_LAYOUT,
    layout,
  });
}

function* changeDashboardLibraryFilters({queryParams, showDashboardsFilter}) {
  const filtersData = {
    queryParams,
    showDashboardsFilter,
  };
  steveDataStorage('dashboards_library', 'filters', true).set(queryParams, 'query_params');
  yield put({
    type: ActionTypes.SET_DASHBOARD_LIBRARY_FILTERS,
    filtersData,
  });
}

function* getDashboardOptionsForUser() {
  const dashboardOptionsForUser = yield UserService.getDashboardOptionsForUser();
  yield put({
    type: ActionTypes.SET_SHORTCUT_AND_HOTKEYS_OPTIONS,
    shortcutAndHotkeysOptions: {
      enableFavoriteHotkeys: dashboardOptionsForUser.enableFavoriteHotkeys,
      enableFavoriteShortcuts: dashboardOptionsForUser.enableFavoriteShortcuts,
    },
  });

  yield put({
    type: ActionTypes.SET_ROTATION,
    dashboardRotation: dashboardOptionsForUser.delay,
  });

  const isLightThemeActive = dashboardOptionsForUser.theme === 'LIGHT';
  yield put({
    type: ActionTypes.SET_THEME,
    isLightThemeActive,
  });

  yield put({
    type: ActionTypes.SET_OPEN_SOLUTIONS_IN_NEW_TAB,
    openSolutionsInNewTab: dashboardOptionsForUser.openSolutionsInNewTab,
  });
}

function* setTheme(action) {
  const result = yield UserService.setTheme(action.isLightThemeActive);
  if (result) {
    yield put({
      type: ActionTypes.SET_THEME,
      isLightThemeActive: action.isLightThemeActive,
    });
  }
}

export default function* userSaga() {
  yield takeEvery(ActionTypes.CHANGE_DASHBOARD_LIBRARY_LAYOUT, changeDashboardLibraryLayout);
  yield takeEvery(ActionTypes.CHANGE_DASHBOARD_LIBRARY_FILTERS, changeDashboardLibraryFilters);
  yield takeEvery(ActionTypes.GET_DASHBOARD_OPTIONS_FOR_USER, getDashboardOptionsForUser);
  yield takeEvery(ActionTypes.SET_THEME_SERVICE_TRIGGER, setTheme);
}
